const calcTableHeight = (tableElement) => {
  const { clientHeight } = document.documentElement;
  const { top } = tableElement.getBoundingClientRect();
  const height = clientHeight - top - 70;

  return height < 300 ? 'auto' : height;
};

export default calcTableHeight;
